export const TEAM_STATUS = {
  STATUS_REQUEST: 1,
  STATUS_ACTIVE: 2,
  STATUS_REJECTED: 3,
  STATUS_DRAFT: 4,
};

export default {
  TEAM_STATUS,
};
